module.exports = __webpack_public_path__ + "static/media/sleepyDragonzFrame3.1c52cb04.png";